import { useEffect, useReducer } from 'react';
import { tolgee } from '../tolgee';

// Same contract as @tolgee/react's useTranslate, but bound to the module
// singleton instead of React context: re-renders on Tolgee `update` events
// (language switches, in-context edits) and keeps working when rendered
// without providers (as the i18n-js implementation did, e.g. in tests).
export const useTolgeeUpdates = (): void => {
  const [, rerender] = useReducer((tick: number) => tick + 1, 0);
  useEffect(() => {
    const subscription = tolgee.on('update', rerender);
    return () => subscription.unsubscribe();
  }, []);
};
